import { gql } from "@apollo/client";

export const MediaFlexibleContentFragment = gql`
  fragment MediaFlexibleContent on CeremonyLanding {
    mediaFlexibleContent {
      ... on CeremonyLandingMediaFlexibleContentVideoPlaylistLayout {
        eyebrow
        headline
        body
        primaryVideo {
          performanceName
          videoType
          youtubeVideoId
          videoUrl
          videoThumbnail {
            ...ACFMedia
          }
          youtubeThumbnail {
            ...ACFMedia
          }
        }
        videos {
          performanceName
          videoType
          youtubeVideoId
          videoUrl
          videoThumbnail {
            ...ACFMedia
          }
          youtubeThumbnail {
            ...ACFMedia
          }
        }
      }
      ... on CeremonyLandingMediaFlexibleContentImageGalleryLayout {
        variant
        standardHeader {
          headline
          subhead
        }
        textHeader {
          eyebrow
          headline
          subhead
          cta {
            linkType
            label
            externalLink
            page {
              node {
                uri
              }
            }
          }
          lineItems {
            headline
            body
          }
        }
        imageGalleryImages: images {
          image {
            ...ACFMedia
          }
        }
      }
      ... on CeremonyLandingMediaFlexibleContentVideoCarouselLayout {
        eyebrow
        headline
        body
        videos {
          title
          videoEmbed {
            videoType
            youtubeVideoId
            videoUrl
            videoThumbnail {
              ...ACFMedia
            }
            youtubeThumbnail {
              ...ACFMedia
            }
          }
        }
      }
    }
  }
`;